import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import {BehaviorSubject, forkJoin, Observable} from 'rxjs';
import {map, retry} from 'rxjs/operators';
import {FusionAuthService} from '../../../shared/services/fusion-auth';
import {UrlProviderService} from '../../../shared/services/general';
import {SECURED_STORE} from '../../../shared/utils';
import {AppState} from '../../../stores/app.state';
import {Physician} from '../models/order-entry/physician';
import {Diagnosis} from "../models";

@Injectable({
  providedIn: 'root'
})
export class PhysicianService {
  constructor(private urlProvider: UrlProviderService, private httpClient: HttpClient,
              private router: Router,
              private store: Store<AppState>, private fusionAuthService: FusionAuthService) {
    this.searchCustomStore = this.searchCustomStore.bind(this);
  }

  public searchCustomStore(firstName: string, lastName: string, npi: string, patientClientId: number, clientIds: number[], dataSource: BehaviorSubject<DataSource>): CustomStore {
    const loadParams = {
      firstName: firstName !== null ? firstName : null,
      lastName: lastName !== null ? lastName : null,
      npi: npi !== null ? npi : null,
      patientClientId,
      clientIds
    };

    return SECURED_STORE({
      routerService: this.router,
      dataSource,
      tokenRefresh: this.fusionAuthService.exchangeRefreshTokenForJWT(),
      loadParams,
      loadUrl: `${this.urlProvider.ApiUrl}/v2/physicians/remote-operations`
    });
  }

  public customStoreByClientsIds(clientIds: number[], dataSource: BehaviorSubject<DataSource>) {
    let url = `/v2/physicians/remote-operations-all-entries`;
    if (clientIds.length > 0) {
      url = url + `?`;
      const clientIdsArray: string[] = [];
      clientIds.map(x => {
        clientIdsArray.push(`clientIds=${x}`);
      });
      url += clientIdsArray.join('&');
    }

    return SECURED_STORE({
      routerService: this.router,
      dataSource,
      tokenRefresh: this.fusionAuthService.exchangeRefreshTokenForJWT(),
      loadParams: undefined,
      loadUrl: `${this.urlProvider.ApiUrl}${url}`
    });
  }

  public getByIds(physicianIds: number[] = []): Observable<Physician[]> {
    let url = `/v2/physicians/ids?`;
    const physicianIdsArray: string[] = [];
    physicianIds.map(x => {
      physicianIdsArray.push(`ids=${x}`);
    });

    if (physicianIdsArray.length > 0) {
      url += physicianIdsArray.join('&');
    }

    return this.httpClient.get<Physician[]>(`${this.urlProvider.ApiUrl}${url}`).pipe(retry(2));
  }

  public getBestMatchByName(firstname: string, lastname: string): Observable<Physician> {
    return this.httpClient.get<Physician>(`${this.urlProvider.ApiUrl}/v2/physicians/by-name?firstname=${firstname}&lastname=${lastname}`);
  }

  public getBestMatchByNpi(npi: string): Observable<Physician> {
    return this.httpClient.get<Physician>(`${this.urlProvider.ApiUrl}/v2/physicians/by-npi?npi=${npi}`);
  }
}
